import React, { useCallback, useEffect, useRef } from 'react';
import { Participant } from 'livekit-client';
import { Grid } from 'features/ParticipantItem/presenters/Grid';
import { useFixedScroll } from 'ui/hooks/useFixedScroll';
import { LARGE_ROOM_PARTICIPANTS_THRESHOLD } from '../../../consts';
import { useParticipantSubscriptions } from '../../../hooks/useParticipantSubscriptions';
import { useParticipantElementRefs } from '../../../hooks/useParticipantElementRefs';
import { GridParticipant, GridParticipantsView } from './view';
import { useGridFixedSlots } from './hooks/useGridFixedSlots';

interface Props {
    participants: Participant[];
    room?: any;
}

export const GridParticipants: React.FC<Props> = ({ participants, room }) => {
    const gridRef = useRef<HTMLDivElement>(null);
    const { scrollPosition, handleScroll: handleFixedScroll } = useFixedScroll();

    useGridFixedSlots(participants.length);

    const { setElementRef } = useParticipantSubscriptions({
        room,
        participants,
        maxVisible: LARGE_ROOM_PARTICIPANTS_THRESHOLD,
    });

    const elementRefs = useParticipantElementRefs(setElementRef, participants);

    // Фиксируем скролл при пересортировке участников
    useEffect(() => {
        if (gridRef.current) {
            gridRef.current.scrollTop = scrollPosition;
        }
    }, [participants, scrollPosition]);

    const handleScrollWithFixed = useCallback(
        (e: React.UIEvent<HTMLDivElement>) => {
            handleFixedScroll(e);
        },
        [handleFixedScroll],
    );

    return (
        <GridParticipantsView $participants={participants.length} onScroll={handleScrollWithFixed} ref={gridRef}>
            {participants.map((participant) => {
                return (
                    <div
                        key={participant.identity}
                        ref={elementRefs.get(participant.identity)}
                        data-participant-id={participant.identity}
                    >
                        <GridParticipant
                            participant={participant}
                            showConnectionQuality
                            PresenterComponent={Grid}
                            withSpeakerIndicator
                        />
                    </div>
                );
            })}
        </GridParticipantsView>
    );
};
